const base = {
    get() {
        // 生产环境使用域名，开发环境使用本地代理
        const baseUrl = process.env.NODE_ENV === 'production'
            ? 'https://puwaike.icu/ssm68n0w/'
            : 'http://localhost:8080/ssm68n0w/';
        return {
            url : baseUrl,
            name: "ssm68n0w",
            // 退出到首页链接
            indexUrl: baseUrl + 'front/h5/index.html'
        };
    },
    getProjectName(){
        return {
            projectName: "医院挂号预约系统"
        } 
    }
}
export default base
